import { BaseWebComponent } from "./webcomponent-base";
import { SidebarAvatarWebComponent } from "./webcomponent-sidebar-avatar";
import { SidebarContentWebComponent } from "./webcomponent-sidebar-content";
import { SidebarDividerWebComponent } from "./webcomponent-sidebar-divider";
import { SidebarFooterWebComponent } from "./webcomponent-sidebar-footer";
import { SidebarHeaderWebComponent } from "./webcomponent-sidebar-header";
import { SidebarItemWebComponent } from "./webcomponent-sidebar-item";
import { SidebarNavWebComponent } from "./webcomponent-sidebar-nav";
import { SidebarSectionWebComponent } from "./webcomponent-sidebar-section";
import { SidebarSubItemWebComponent } from "./webcomponent-sidebar-subitem";
import { SidebarToggleWebComponent } from "./webcomponent-sidebar-toggle";
interface SetupSidebarOptions {
    sidebarMobileToggleSelector?: string;
}
const defaultOptions: SetupSidebarOptions = {
    sidebarMobileToggleSelector: '.mobile-sidebar-toggle,button[data-mobile-sidebar-toggle]',
}
// Dichiarazione delle funzioni globali per la gestione della sidebar
declare global {
    interface Window {
        toggleSidebar: () => void;
        hideSidebar: () => void;
        showSidebar: () => void;
        toggleMobileSidebar: () => void;
        hideMobileSidebar: () => void;
        showMobileSidebar: () => void;
    }
}

export class SidebarWebComponent extends BaseWebComponent {
    static webComponentName = "wc-sidebar";
    static observedAttributes = [
        // List of attributes to observe for changes

    ];
    private _options!: SetupSidebarOptions;
    public get options(): SetupSidebarOptions {
        if (!this._options) {
            this._options = {
                ...defaultOptions
            }
        }
        return this._options;
    }


    private backdropElement!: HTMLElement | null;
    private sidebarMobileToggleElement !: HTMLElement | null;
    setState(state: 'collapsed' | 'hidden' | 'open' | 'mobile-open' | 'mobile-close') {
        const validStates = ['collapsed', 'hidden', 'open', 'mobile-open', 'mobile-close'];
        const isStateValid = validStates.includes(state);
        if (!isStateValid) {
            return;
        }
        const options = this.options;
        validStates.forEach(s => {
            document.body.classList.remove(`sidebar-${s}`);
        });
        document.body.classList.add(`sidebar-${state}`);
    }
    constructor() {
        super();
        window.toggleSidebar = this.toggleSidebar.bind(this);
        window.hideSidebar = this.hideSidebar.bind(this);
        window.showSidebar = this.showSidebar.bind(this);
        window.toggleMobileSidebar = this.toggleMobileSidebar.bind(this);
        window.hideMobileSidebar = this.hideMobileSidebar.bind(this);
        window.showMobileSidebar = this.showMobileSidebar.bind(this);
    }
    private initializeSidebar() {
        const options = this.options;
        this.classList.add('sidebar');
        document.body.classList.add('has-sidebar');

        const initialState = this.getAttribute('state');
        if (initialState === 'collapsed') {
            this.setState('collapsed');
        } else if (initialState === 'hidden') {
            this.setState('hidden');
        } else {
            this.setState('open');
        }
        // crea elemento backdrop 
        this.backdropElement = document.querySelector(`.sidebar-backdrop`);
        if (!this.backdropElement) {
            this.backdropElement = document.createElement('div');
            this.backdropElement.className = 'sidebar-backdrop';
            this.insertAdjacentElement('afterend', this.backdropElement);
        }
        if (this.backdropElement) {
            this.backdropElement.addEventListener('click', (e) => {
                e.preventDefault();
                this.hideMobileSidebar();
            });
        }
        this.sidebarMobileToggleElement = document.querySelector(options.sidebarMobileToggleSelector || '.mobile-sidebar-toggle,button[data-mobile-sidebar-toggle]');
        if (!this.sidebarMobileToggleElement) {
            console.warn(`Mobile sidebar toggle element not found page will not work at low resolutions`);
        }
        else {
            this.sidebarMobileToggleElement.addEventListener('click', (e) => {
                e.preventDefault();
                this.toggleMobileSidebar();
            });
        }
    }
   
    toggleSidebar() {
        if (document.body.classList.contains('sidebar-collapsed')) {
            this.setState('open');
        } else {
            this.setState('collapsed');
        }
    };
    hideSidebar() {
        this.setState('hidden');
    }
    showSidebar() {
        this.setState('open');
    }
    toggleMobileSidebar() {
        if (document.body.classList.contains('sidebar-mobile-open')) {
            this.hideMobileSidebar();
        } else {
            this.showMobileSidebar();
        }
    }
    hideMobileSidebar() {
        this.setState('mobile-close');
    }
    showMobileSidebar() {
        this.setState('mobile-open');
    }
    protected onConnected(): void {
        this.initializeSidebar();
        // this.initializeSidebar(this.options);
    }
    protected onAttributeChange(name: string, oldValue: string, newValue: string): void {
        // Handle attribute changes if necessary

    }
    static registerElement() {
        super.registerElement();
        SidebarHeaderWebComponent.registerElement();
        SidebarContentWebComponent.registerElement();
        SidebarToggleWebComponent.registerElement();
        SidebarNavWebComponent.registerElement();
        SidebarSectionWebComponent.registerElement();
        SidebarDividerWebComponent.registerElement();
        SidebarItemWebComponent.registerElement();
        SidebarSubItemWebComponent.registerElement();
        SidebarFooterWebComponent.registerElement();
        SidebarAvatarWebComponent.registerElement();
    }

}


